import {
    Avatar,
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
    useGetAllReservationsDetailedQuery,
    useGetReportQuery,
} from '../../../../app/Slices/SevenDayApiSlice';
import { useNavigate } from 'react-router-dom';
import { CalendarMonth, NavigateNext } from '@mui/icons-material';
import { Data } from '../../../types/dashboard';
import SkeletonLayout from '../v2/SkeletonLayout';
import { Period } from '../../../enums/reports';
import { Status } from '../../../enums/booking';

export default function UserDashboardSmallerStats() {
    const [dashboardData, setDashboardData] = useState<Data[]>([
        {
            reportName: 'Scheduled This Month',
            reportUrl: 'current-month',
            icon: <CalendarMonth />,
        },
        {
            reportName: 'Your Pending Requests',
            reportUrl: 'user-pending-bookings',
            icon: <CalendarMonth />,
        },
        {
            reportName: 'Your Upcoming Reservations',
            reportUrl: 'user-approved-bookings',
            icon: <CalendarMonth />,
        },
        {
            reportName: 'Your Completed Reservations',
            reportUrl: 'user-completed-bookings',
            icon: <CalendarMonth />,
        },
    ]);

    //GET REPORT
    const { data: getThisMonth } = useGetAllReservationsDetailedQuery({
        startDate: Period.CurrentMonth,
        status: [Status.Approved, Status.Completed],
    });

    const { data: getPendingReservations } = useGetReportQuery(
        `/dashboard/user-pending-bookings`,
    );
    const { data: getApprovedReservations } = useGetReportQuery(
        `/dashboard/user-approved-bookings`,
    );
    const { data: getCompletedReservations } = useGetReportQuery(
        `/dashboard/user-completed-bookings`,
    );

    const theme = useTheme();

    useEffect(() => {
        const data = [
            {
                reportName: 'Scheduled This Month',
                reportUrl: 'current-month',
                statNo: getThisMonth?.length,
                icon: <CalendarMonth />,
            },
            {
                reportName: 'Your Pending Requests',
                reportUrl: 'user-pending-bookings',
                statNo: getPendingReservations?.length,
                icon: <CalendarMonth />,
            },
            {
                reportName: 'Your Upcoming Reservations',
                reportUrl: 'user-approved-bookings',
                statNo: getApprovedReservations?.length,
                icon: <CalendarMonth />,
            },
            {
                reportName: 'Your Completed Reservations',
                reportUrl: 'user-completed-bookings',
                statNo: getCompletedReservations?.length,
                icon: <CalendarMonth />,
            },
        ];
        setDashboardData(data);
    }, [
        getThisMonth,
        getPendingReservations,
        getApprovedReservations,
        getCompletedReservations,
    ]);

    const navigate = useNavigate();

    const handleOpen = (item: Data) => {
        if (item.reportName?.includes('Scheduled')) {
            navigate(`/dashboard/scheduled/${item.reportUrl}`);
        } else {
            navigate(`/dashboard/user/${item.reportUrl}`);
        }
    };

    return (
        <>
            {dashboardData.map((dashboardItem) => (
                <Grid item xs={12} md={6} lg key={dashboardItem.reportName}>
                    <Card
                        sx={{
                            height: '100%',
                            cursor: 'pointer',
                            transition: '0.3s ease-in-out',
                        }}
                        onClick={() => handleOpen(dashboardItem)}
                    >
                        <CardContent sx={{ m: 1 }}>
                            {dashboardItem.statNo !== undefined ? (
                                <div>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 0.5,
                                        }}
                                    >
                                        <Avatar
                                            variant='rounded'
                                            sx={{
                                                height: 25,
                                                width: 25,
                                                bgcolor:
                                                    theme.palette.neutral.main,
                                                color: 'text.primary',
                                            }}
                                        >
                                            {dashboardItem.icon}
                                        </Avatar>
                                        <Typography sx={{ fontWeight: 'bold' }}>
                                            {dashboardItem.reportName}
                                        </Typography>
                                        <NavigateNext />
                                    </Box>
                                    <Typography
                                        sx={{
                                            fontSize: '3rem',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {dashboardItem.statNo}
                                    </Typography>
                                </div>
                            ) : (
                                <SkeletonLayout />
                            )}
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </>
    );
}
